import React from 'react';
import ReactDOM from 'react-dom';
import BootstrapPopover from './BootstrapPopover';


export default class PopoverTrigger extends React.Component {
  constructor(props) {
    super(props);
    this.state = { active: props.alwaysActive };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.alwaysActive && !this.props.alwaysActive) {
      this.setState({active: true});
    }
  }

  getPopoverTarget = () => ReactDOM.findDOMNode(this); // eslint-disable-line react/no-find-dom-node

  handleClose = () => {
    if (this.props.alwaysActive) {
      return false;
    }
    if (this.state.active) {
      this.setState({ active: false });
    }
  };

  handleOpen = () => {
    if (!this.state.active) {
      this.setState({ active: true });
    }
  };

  renderPopover() {
    return (
      <BootstrapPopover
        placement={this.props.placement}
        getTarget={this.getPopoverTarget}
        onOutClick={this.handleClose}
        type={this.props.type}
        onTop={this.props.onTop}
      >
        {this.props.content}
      </BootstrapPopover>
    );
  }

  renderChildrenWithPopover(children) {
    if (!this.state.active) {
      return children;
    }

    const popover = this.renderPopover();

    if (children === null) {
      return popover;
    }

    if (typeof children !== 'object' || React.isValidElement(children)) {
      return [children, popover];
    }

    return [...children, popover];
  }

  render() {
    const { hideOnMouseLeave, triggerOnHover } = this.props;
    const child = React.Children.only(this.props.children);
    const infectedChildren = this.renderChildrenWithPopover(child.props.children);

    return React.cloneElement(child, {
      children: infectedChildren,
      onClick: this.handleOpen,
      onMouseEnter: triggerOnHover ? this.handleOpen : undefined,
      onMouseLeave: hideOnMouseLeave ? this.handleClose : null,
    });
  }

  static propTypes = {
    children: React.PropTypes.element.isRequired,
    placement: BootstrapPopover.propTypes.placement,
    content: React.PropTypes.node.isRequired,
    hideOnMouseLeave: React.PropTypes.bool,
    type: React.PropTypes.string,
  };

  static defaultProps = {
    hideOnMouseLeave: true,
    triggerOnHover: true
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/popover/PopoverTrigger.jsx
 **/